import {fetchApi} from "@mbj-front-monorepo/data-access";
import {useQuery} from "@tanstack/react-query";

export const useGetMetrixCompForUM = ()=>{
  const promise = () => fetchApi("/api/metrix_comp_user_metiers", { method: "get" });
  return useQuery<Awaited<ReturnType<typeof promise>>, Error>(["um_metrix_comp"], promise);
}
